const de = {
    '/': {
        title: '{brand} & Sportwetten | Sofortige Auszahlungen',
        description: '{brand} und Sportwetten in einer Wallet. Spielautomaten, Live-Casino und Sportwetten mit sofortiger Krypto-Auszahlung.',
        keywords: 'krypto casino, bitcoin casino, krypto sportwetten, online spielautomaten, sofortauszahlung casino, provably fair casino'
    },
    '/casino': {
        title: '{brand} Online Casino | Slots, Blackjack & Live-Dealer',
        description: 'Slots, Blackjack, Roulette & Live-Dealer bei {brand}. Hunderte Spiele, schnelle Krypto-Einzahlungen & Sofortauszahlungen rund um die Uhr.',
        keywords: 'krypto casino, bitcoin casino spiele, online casino, krypto spielautomaten, live casino, blackjack, roulette'
    },
    '/sports': {
        title: '{brand} Online-Sportwetten | Krypto-Wetten & Quoten',
        description: 'Sportwetten bei {brand}. Attraktive Quoten auf Fußball, Basketball & mehr. Live-Wetten, sichere Krypto-Einsätze & schnelle Auszahlungen.',
        keywords: 'krypto sportwetten, bitcoin wetten, live wetten, fussball quoten, basketball wetten, esports wetten'
    },
    '/livecasino': {
        title: '{brand} Live-Casino | Blackjack, Roulette & Live-Dealer',
        description: 'Blackjack, Roulette & Live-Casino-Spiele bei {brand}. Echte Dealer, HD-Streaming & eine große Auswahl an Live-Tischen rund um die Uhr.',
        keywords: 'live casino, live dealer spiele, live blackjack, live roulette, live baccarat, game shows'
    },
    '/slots': {
        title: '{brand} Online-Slots | Riesige Auswahl an Casino-Slots',
        description: 'Eine riesige Sammlung von Slots bei {brand}. Klassische Automaten, Video-Slots & Progressive-Jackpots - alle mit Krypto spielbar.',
        keywords: 'krypto spielautomaten, bitcoin slots, online slots, video slots, megaways slots, bonus kauf slots'
    },
    '/vip': {
        title: '{brand} VIP-Programm | Exklusive Belohnungen & Vorteile',
        description: 'Das VIP-Programm von {brand}: exklusive Belohnungen, personalisierte Boni und priorisierter Support. Vorteile für treue Spieler.',
        keywords: 'casino vip programm, rakeback, treueprämien casino, high roller casino, vip stufen'
    },
    '/welcome-offer': {
        title: '{brand} Willkommensbonus | Krypto Casino',
        description: 'Entdecken Sie das Willkommensangebot von {brand}. Starten Sie mit Krypto und genießen Sie exklusive Boni für neue Spieler.',
        keywords: 'casino willkommensbonus, krypto casino bonus, ersteinzahlungsbonus, neukundenangebot'
    },
    '/referral': {
        title: '{brand} Empfehlungsprogramm | Belohnungen Verdienen',
        description: 'Laden Sie Freunde zu {brand} ein und verdienen Sie Belohnungen, wenn diese mitmachen und die Bedingungen erfüllen.',
        keywords: 'casino empfehlungsprogramm, freunde werben bonus, partner prämien'
    },
    '/promotion-page': {
        title: '{brand} Aktionen | Boni & Sonderangebote',
        description: 'Alle aktiven Aktionen bei {brand}. Boni, Freispiele und Sonderangebote für Krypto-Spieler.',
        keywords: 'casino aktionen, krypto casino boni, wöchentliches rennen, casino turniere'
    },
    '/hotslots': {
        title: '{brand} Hot Slots | Beliebteste Casino-Slots',
        description: 'Spielen Sie die beliebtesten Slot-Spiele bei {brand}. Die heißesten Slots sind mit Krypto verfügbar.'
    },
    '/newgames': {
        title: '{brand} Neue Spiele | Neueste Casino-Spiele',
        description: 'Entdecken Sie die neuesten Casino-Spiele bei {brand}. Neue Slots, Live-Spiele und Tischspiele erscheinen regelmäßig.'
    },
    '/populargames': {
        title: '{brand} Beliebte Spiele | Top Casino-Spiele',
        description: 'Die beliebtesten Casino-Spiele bei {brand}. Von Slots bis Live-Spiele - alles mit Krypto verfügbar.'
    },
    '/gameshows': {
        title: '{brand} Game Shows | Casino mit Live-Shows',
        description: 'Genießen Sie Live-Game-Shows bei {brand}. Echte Moderatoren, einzigartige Spiele und große Gewinne in Echtzeit.'
    },
    '/table_games': {
        title: '{brand} Tischspiele | Blackjack, Roulette & Baccarat',
        description: 'Spielen Sie Blackjack, Roulette, Baccarat und weitere Tischspiele bei {brand}. Alles mit Krypto verfügbar.'
    },
    '/hotlive': {
        title: '{brand} Beliebtes Live-Casino | Top Live-Casino-Spiele',
        description: 'Die beliebtesten Live-Casino-Spiele bei {brand}. Spielen Sie mit echten Dealern in Echtzeit.'
    },
    '/featurebuyin': {
        title: '{brand} Slots mit Bonus-Kauf | Feature Buy-in',
        description: 'Spielen Sie Slots mit der Möglichkeit, die Bonusrunde bei {brand} zu kaufen. Direkt in die Bonusrunde ohne Warten.'
    },
    '/originals': {
        title: '{brand} Original Casino-Spiele | Exklusive Titel',
        description: 'Spielen Sie exklusive Originalspiele bei {brand}. Einzigartige Titel, die Sie nirgendwo sonst finden - intern entwickelt für ein unvergleichliches Casino-Erlebnis.'
    },
    '/providers': {
        title: '{brand} Spieleanbieter | Partner-Studios & Software',
        description: 'Entdecken Sie alle Spieleanbieter bei {brand}. Wir arbeiten mit Top-Studios zusammen, um Ihnen eine vielfältige, hochwertige Krypto-Casino-Bibliothek zu bieten.'
    },
    '/about-us': {
        title: 'Über Uns | Mehr über {brand} erfahren',
        description: 'Erfahren Sie mehr über {brand}, ein führendes Krypto-Casino & Sportwetten-Anbieter. Wir setzen auf sichere, faire & aufregende Glücksspiele mit sofortigen Krypto-Auszahlungen.'
    },
    '/affiliate': {
        title: 'Affiliate-Programm | Krypto verdienen mit {brand}',
        description: 'Werden Sie Partner von {brand} & verdienen Sie Provisionen für die Bewerbung unseres Krypto-Casinos. Wettbewerbsfähige Raten, Echtzeit-Tracking & dedizierter Affiliate-Support.'
    },
    '/faq': {
        title: '{brand} FAQ | Häufig gestellte Fragen',
        description: 'Finden Sie Antworten auf häufige Fragen zu {brand}. Durchsuchen Sie unsere FAQ zu Konten, Zahlungen, Boni & Casino-Spielen.'
    },
    '/aml-policy': {
        title: 'AML-Richtlinie | Geldwäscheprävention bei {brand}',
        description: 'Die AML-Richtlinie von {brand} gewährleistet eine sichere, vertrauenswürdige Umgebung. Erfahren Sie mehr über unsere Maßnahmen zur Verhinderung illegaler Aktivitäten.'
    },
    '/bonus-terms': {
        title: 'Bonusbedingungen | {brand} Aktionen',
        description: 'Lesen Sie die Regeln für Boni & Aktionen bei {brand}. Erfahren Sie, wie Sie Bonusgewinne beanspruchen, nutzen & auszahlen lassen können.'
    },
    '/complaints-and-arbitration': {
        title: 'Beschwerden und Schiedsverfahren | Spieler-Support bei {brand}',
        description: 'Erfahren Sie mehr über das Beschwerde- und Streitbeilegungsverfahren von {brand}. Wir gewährleisten faire Behandlung und lösen Spielerprobleme schnell und transparent.'
    },
    '/fairness': {
        title: 'Nachweislich Faire Spiele | Fairness bei {brand}',
        description: '{brand} verwendet nachweislich faire Technologie, um sicherzustellen, dass jedes Spielergebnis überprüfbar, transparent & vollständig zufällig ist.'
    },
    '/kyc-policy': {
        title: 'KYC-Richtlinie | Kundenidentifikation bei {brand}',
        description: 'Die KYC-Richtlinie von {brand} beschreibt unser Identitätsverifizierungsverfahren. Erfahren Sie, wie wir Spieler schützen und eine sichere Spielumgebung aufrechterhalten.'
    },
    '/payment-policy': {
        title: '{brand} Zahlungsrichtlinie | Krypto-Ein- & Auszahlungen',
        description: '{brand} akzeptiert Krypto-Einzahlungen & Auszahlungen. Lesen Sie unsere Zahlungsrichtlinie für Transaktionslimits, akzeptierte Kryptowährungen & Bearbeitungszeiten.'
    },
    '/privacy-policy': {
        title: 'Datenschutzrichtlinie | Datenschutz bei {brand}',
        description: 'Die Datenschutzrichtlinie von {brand}. Erfahren Sie, wie wir Ihre persönlichen Daten auf unserer Krypto-Casino-Plattform erheben, verwenden & schützen.'
    },
    '/responsible-gaming': {
        title: 'Verantwortungsvolles Spielen | Sicher spielen bei {brand}',
        description: '{brand} ist dem verantwortungsvollen Glücksspiel verpflichtet. Nutzen Sie Tools & Ressourcen, um Ihre Spielgewohnheiten zu verwalten und sicher zu spielen.'
    },
    '/terms-of-service': {
        title: 'Nutzungsbedingungen | {brand}',
        description: 'Lesen Sie die allgemeinen Geschäftsbedingungen für die Nutzung von {brand}. Verstehen Sie Ihre Rechte und Pflichten als Spieler.'
    },
    '/terms-sports': {
        title: 'Sportwetten-Bedingungen | {brand}',
        description: 'Die Sportwetten-Bedingungen von {brand}. Regeln für das Platzieren von Wetten, Gewinnauszahlungen & die Nutzung des Sportsbooks auf unserer Plattform.'
    },
    '/special-bets': {
        title: 'Spezialwetten | Krypto-Sportwetten bei {brand}',
        description: 'Platzieren Sie Spezialwetten bei {brand}. Wettmärkte für Sport, Esport & einmalige Events, mit sofortigen Krypto-Einzahlungen und schnellen Auszahlungen.'
    },
    '/transparency': {
        title: '{brand} Transparenz | Beweisbar faires Krypto-Casino',
        description: 'Sehen Sie, wie {brand} offen arbeitet. Beweisbar faire Spielverifizierung, veröffentlichte Auszahlungsquoten aus dem Live-Katalog & On-Chain-Auszahlungen.'
    },
    '/faq/about': {
        title: 'Über {brand} | FAQ',
        description: 'Über {brand}: Lizenzierung, wie das Krypto-Casino funktioniert & was die Plattform fair macht. Antworten auf häufige Fragen.'
    },
    '/faq/account': {
        title: '{brand} Konto | FAQ',
        description: 'Ihr {brand}-Konto verwalten: Registrierung, Login, Verifizierung & Profileinstellungen. Antworten auf häufige Kontofragen.'
    },
    '/faq/bonuses': {
        title: '{brand} Boni | FAQ',
        description: 'Boni bei {brand} erklärt: Willkommensangebote, Promo-Codes, Umsatzbedingungen & Prämien. Antworten auf häufige Bonusfragen.'
    },
    '/faq/deposits': {
        title: '{brand} Einzahlungen | FAQ',
        description: 'Krypto bei {brand} einzahlen: unterstützte Coins, Netzwerke, Mindestbeträge & Bestätigungszeiten. Antworten auf häufige Einzahlungsfragen.'
    },
    '/faq/games-sports': {
        title: '{brand} Spiele & Sport | FAQ',
        description: 'Casinospiele & Sportwetten bei {brand}: Anbieter, beweisbare Fairness, Quoten & Live-Wetten. Antworten auf häufige Fragen.'
    },
    '/faq/responsible-gambling': {
        title: '{brand} Verantwortungsvolles Spielen | FAQ',
        description: 'Verantwortungsvolles Spielen bei {brand}: Einzahlungslimits, Selbstausschluss, Abkühlphasen & Hilfsangebote für sicheres Spiel.'
    },
    '/faq/security': {
        title: '{brand} Sicherheit | FAQ',
        description: 'Sicherheit bei {brand}: Kontoschutz, Zwei-Faktor-Authentifizierung, Fairness & Datenschutz. Antworten auf häufige Sicherheitsfragen.'
    },
    '/faq/support-disputes': {
        title: '{brand} Support & Streitfälle | FAQ',
        description: 'Hilfe bei {brand}: Live-Chat, Antwortzeiten & wie Streitfälle gelöst werden. Antworten auf häufige Supportfragen.'
    },
    '/faq/withdrawals': {
        title: '{brand} Auszahlungen | FAQ',
        description: 'Krypto bei {brand} auszahlen: Auszahlungszeiten, Mindestbeträge, Gebühren & Limits. Antworten auf häufige Auszahlungsfragen.'
    }
};
export default de;
